<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block">
        <!-- <div class="row col-sm-4" style=" float: right;  margin:10px;">
            <span><input type="text" class="form-control col-sm-12 col-lg-6" placeholder="Enter ID" [(ngModel)]="mapId"
                    style="float: left; margin-right: 20px;" />
                <input type="button" class="btn btn-primary col-sm-12 col-lg-4" value="Show" (click)="showMap(true)">
            </span>
        </div> -->
        <div class="map-container">
            <div>
                <!-- <pre>{{ mapUrl}}</pre> -->
                <iframe width="98%" height="570px%" frameBorder="0" [src]="mapUrl" scrolling=" no"
                    style="overflow:hidden;margin-bottom:5px; margin: 20px;" *ngIf="mapId"></iframe>
                <!-- <iframe [src]="mapUrl"></iframe> -->
            </div>
        </div>
    </div>
</div>